import { normalize } from 'styled-normalize';
import { css, createGlobalStyle } from 'styled-components';

import {
  heading1,
  heading2,
  heading3,
  bodyRegular,
  bodySemibold,
  captionRegular,
} from './mixins/fonts';

const GlobalStyles = createGlobalStyle`
  ${normalize}

  ${({ theme }) => css`
    ::-webkit-scrollbar {
      background-color: transparent;
      border-radius: 0;
      height: 8px;
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar:hover {
      background-color: transparent;
    }

    ::-webkit-scrollbar:active {
      background-color: transparent;
    }

    html {
      *:hover::-webkit-scrollbar {
        background-color: transparent;
      }

      *:hover::-webkit-scrollbar-thumb {
        background-color: ${theme.scrollBar.standard};
        background-clip: padding-box;
        border-radius: 4px;
        padding: 100px 0 0;
      }

      *::-webkit-scrollbar-thumb:hover {
        background-color: ${theme.scrollBar.hover};
      }

      *::-webkit-scrollbar-thumb:active {
        background-color: ${theme.scrollBar.action};
      }

      * {
        // ff scrollbar
        scrollbar-width: thin;
        scrollbar-color: ${theme.scrollBar.standard} transparent;
      }
    }
  `};

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-family: Mukta, sans-serif;
  }

  body {
    ${bodyRegular};
    overflow-x: hidden;
    overflow-y: hidden;
    color: ${({ theme }) => theme.config.text.primary};
    background-color: ${({ theme }) => theme.config.background};
  }

  a {
    ${bodyRegular};
    text-decoration: none;
    ${({ theme }) => css`
      color: ${theme.config.link.default};

      &:hover {
        color: ${theme.config.link.hover};
      }

      &:active {
        color: ${theme.config.link.action};
      }
    `};
    outline: none;
  }

  ul {
    list-style-type: none;
  }

  button {
    border: none;
    color: inherit;
    cursor: pointer;
    ${bodySemibold};
    line-height: inherit;
    background-color: inherit;
    
    svg:not(.svg-non-filled) {
     path, circle {
      fill: ${({ theme }) => theme.config.common.icon};
     }
    } 
  }

  input {
    ${bodyRegular};
    color: inherit;
  }
  
  textarea {
    color: inherit;
    background-color: inherit;
    border: none;
  }

  h1 {
    margin: 0;
    ${heading1};
  }

  h2 {
    ${heading2};
  }

  h3 {
    ${heading3};
  }
  
  .rc-tooltip-arrow {
    bottom: 6px !important;
    border-top-color: ${({ theme }) =>
      theme.config.rangeSlider.tooltip.bg} !important;
  }
  
  .semibold {
    ${bodySemibold};
  }

  .caption-regular {
    ${captionRegular};
  }
  
  .__floater__arrow {
    polygon {
      fill: ${({ theme }) => theme.config.background};
    }
  }

  .pac-container {
    z-index: 5000;
  }

  .pre-wrap {
    white-space: pre-wrap;
  }

  .Toastify__toast {
    width: 100%;
    padding: unset;
    border-radius: 16px;
  }
`;

export { GlobalStyles };
